import store from "../store";
import { uiActions } from "../store/ui/ui-slice";
import { defaultAxios } from "../utils/api/axios";
import { APIBaseAdminUrl } from "../utils/constance";

const dispatch = store.dispatch;
export const postAdminAxios = async ({ url, payload }) => {
  dispatch(uiActions.setFormSubmitLoading(true));
  try {
    const config = {
      baseURL: APIBaseAdminUrl,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      url,
      method: "post",
      data: payload,
    };

    const data = await defaultAxios(config);

    if (data && data?.status) {
      // showToast.success(data?.message || "Success");
      return data?.data;
    } else {
      // showToast.error(data?.message || "Invalid data");
      return false;
    }
  } catch (error) {
    return false;
  } finally {
    dispatch(uiActions.setFormSubmitLoading(false));
  }
};

export const getAdminAxios = async ({ url, params }) => {
  dispatch(uiActions.setFormSubmitLoading(true));
  try {
    const config = {
      baseURL: APIBaseAdminUrl,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      url,
      method: "get",
      params,
    };

    const data = await defaultAxios(config);

    if (data) {
      // showToast.success(data?.message || "Success");
      return data?.data || data;
    } else {
      // showToast.error(data?.message || "Invalid data");
      return false;
    }
  } catch (error) {
    console.log("🚀 ~ getAdminAxios ~ error:", error);
    return false;
  } finally {
    dispatch(uiActions.setFormSubmitLoading(false));
  }
};
